import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-model-fields",
  "use": "icon-leo-model-fields-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-model-fields\">\r\n<g transform=\"translate(-113.571 -152.669) scale(1.221818)\">\r\n<path d=\"M192 192h640v128H192V192zm0 192h640v128H192V384zm0 192h640v128H192V576zm0 192h448v128H192V768z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-model-fields.svg
// module id = +Foa
// module chunks = 446